import { useHasActiveSmtpCredential } from "components/messages/use-user-mailboxes";
import React from "react";
import { useProductName } from "store/selectors/branding";
import { UserTogglePref } from "./account-settings-toggle";

export const BccMyselfPref: React.FC = () => {
    const productName = useProductName();
    const hasActiveSmtpCredential = useHasActiveSmtpCredential();
    if (hasActiveSmtpCredential) {
        return null;
    }
    return (
        <UserTogglePref
            field="bccMyself"
            label="BCC myself by default"
            description={`When sending emails from ${productName}, BCC myself by default`}
        />
    );
};
